


































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { getServerOptions, PageOptions } from "@/shared/utils/datatable";

export interface PaginationData {
  lista: unknown[];
  totalRegistros: number;
  paginaAtual: number;
  tamanhoPagina: number;
}

export interface TableHeader {
  text: string;
  value: string;
  align?: "start" | "center" | "end";
  sortable?: boolean;
  filterable?: boolean;
  groupable?: boolean;
  divider?: boolean;
  class?: string | string[];
  width?: string | number;
  filter?: (value: unknown, search: string, item: unknown) => boolean;
  sort?: (a: unknown, b: unknown) => number;
  withAliasValue?: string;
}

@Component
export default class DataTable extends Vue {
  @Prop() readonly headers!: TableHeader[];
  @Prop() readonly promise!: Promise<unknown[]> | Promise<PaginationData>;
  @Prop() readonly itemClass!: Function;
  @Prop() readonly customFilter!: Function;
  @Prop() readonly search!: unknown;
  @Prop() readonly showExpand!: boolean;
  @Prop() readonly itemKey!: string;
  @Prop() readonly disablePagination!: boolean;
  @Prop() readonly noElevation!: boolean;
  @Prop() readonly selectedRow!: boolean;
  @Prop() readonly itemsPerPage!: number;
  @Prop({ default: null }) readonly itemsMenu!: number[] | null;

  loading = false;
  items: unknown[] = [];
  serverItemsLength: number | null = null;
  options: PageOptions | null = null;
  lockOptions = false;

  @Watch("options", { deep: true })
  onOptionsChange(val: PageOptions | null) {
    if (!this.lockOptions && val) {
      //Criando o dicionario de value do header do datatable com o alias da tabela para query de ordenação
      const map = this.headers.reduce(
        (map, item) =>
          Object.assign(map, {
            [item.value]:
              (item.withAliasValue && `${item.withAliasValue}`) || item.value,
          }),
        {},
      );

      this.$emit("options", getServerOptions(val, map));
    }
  }

  @Watch("promise")
  onPromiseChange() {
    this.fetchPromise();
  }

  mounted() {
    this.fetchPromise();
  }

  selectRow(item: any) {
    if (this.selectedRow) {
      this.$emit("selectedRow", item);
    }
  }

  async fetchPromise() {
    try {
      if (this.promise) {
        this.loading = true;
        const response = await this.promise;
        if (Array.isArray(response)) {
          this.items = response;
          this.serverItemsLength = null;
        } else {
          //Paginação Server Side
          this.items = response.lista;
          this.serverItemsLength = response.totalRegistros;

          this.lockOptions = true;
          setTimeout(() => {
            if (this.options) {
              Object.assign(this.options, {
                page: response.paginaAtual,
                itemsPerPage: response.tamanhoPagina,
              });
            }
            setTimeout(() => {
              this.lockOptions = false;
            });
          });
        }
      }
    } catch (ex) {
      console.error(ex);
      throw ex;
    } finally {
      this.loading = false;
    }
  }
}
